import React from 'react';
import { Flex } from '@semcore/ui/flex-box';
import Spin from '@semcore/ui/spin';

const PageLoader = () => {
  return (
    <Flex style={{ gridColumn: '-1/1', gridRow: '-1/1' }}>
      <Spin size={'xxl'} centered />
    </Flex>
  );
};

export default PageLoader;
